module.exports = __webpack_public_path__ + "static/media/onscreen_credits_1080_bc.1ebfc2b3.png";